import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  subscription: {},
  periods: [],
  loading: false,
  fetchingSubscriptionsPeriods: false,
  pagination: {},
  errors: {},
  subscriptions: [],
  fetchedExchange: false,
  fetchedSubsription: false,
  fetchedSubscriptionSuccess: false,
  fetchingChangeVehicle: false,
  fetchedChangeVehicle: false,
  fetchingCancelSubscription: false,
  fetchedCancelSubscription: false,
  fetchedUpdateExchangeType: false,
  fetchingUpdateExchangeType: false,
  fetchingUpdateExchangeAddress: false,
  fetchingSubscriptionPricing: false,
  fetchedSubscriptionPricing: false,
  fetchingUpdateSubscription: false,
  fetchedUpdateSubscription: false,
  subscriptionPricing: [],
  fetchingAggregatesTotals: false,
  fetchingFleetAggregates: false,
  fleetAggregates: {},
  aggregatesTotals: {},
};

const subscriptionsReducer = createReducer(initialState)({
  [types.FETCH_SUBSCRIPTIONS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedSubscriptionSuccess: false,
    };
  },
  [types.FETCH_SUBSCRIPTIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      subscriptions: payload.data,
      pagination: payload.pagination,
      fetchedSubscriptionSuccess: true,
    };
  },
  [types.FETCH_SUBSCRIPTIONS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedSubscriptionSuccess: false,
    };
  },

  [types.FETCH_SUBSCRIPTIONS_PERIODS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingSubscriptionsPeriods: true,
    };
  },
  [types.FETCH_SUBSCRIPTIONS_PERIODS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingSubscriptionsPeriods: false,
      periodsPagination: payload.pagination,
      periods: payload.data,
    };
  },
  [types.FETCH_SUBSCRIPTIONS_PERIODS_FAILED]: (state) => {
    return {
      ...state,
      fetchingSubscriptionsPeriods: false,
    };
  },

  [types.FETCH_SUBSCRIPTION_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
      fetchedSubsription: false,
    };
  },
  [types.FETCH_SUBSCRIPTION_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      subscription: payload,
      fetchedSubsription: true,
    };
  },
  [types.FETCH_SUBSCRIPTION_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
      fetchedSubsription: false,
    };
  },

  [types.FETCH_UPDATE_SUBSCRIPTION_REQUEST]: (state) => {
    return {
      ...state,
      fetchedUpdateSubscription: false,
      fetchingUpdateSubscription: true,
    };
  },
  [types.FETCH_UPDATE_SUBSCRIPTION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedUpdateSubscription: true,
      fetchingUpdateSubscription: false,
      subscription: payload,
    };
  },
  [types.FETCH_UPDATE_SUBSCRIPTION_FAILED]: (state) => {
    return {
      ...state,
      fetchedUpdateSubscription: false,
      fetchingUpdateSubscription: false,
    };
  },

  [types.FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateSubscription: true,
      fetchedUpdateSubscription: false,
    };
  },
  [types.FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingUpdateSubscription: false,
      fetchedUpdateSubscription: true,
      subscription: payload,
    };
  },
  [types.FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_FAILED]: (state) => {
    return {
      ...state,
      fetchingUpdateSubscription: false,
      fetchedUpdateSubscription: false,
    };
  },

  [types.FETCH_CHANGE_VEHICLE_REQUEST]: (state) => {
    return {
      ...state,
      fetchingChangeVehicle: true,
      fetchedChangeVehicle: false,
    };
  },
  [types.FETCH_CHANGE_VEHICLE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      subscription: payload,
      fetchingChangeVehicle: false,
      fetchedChangeVehicle: true,
    };
  },
  [types.FETCH_CHANGE_VEHICLE_FAILED]: (state) => {
    return {
      ...state,
      fetchingChangeVehicle: false,
      fetchedChangeVehicle: false,
    };
  },

  [types.FETCH_CANCEL_SUBSCRIPTION_REQUEST]: (state) => {
    return {
      ...state,
      fetchingCancelSubscription: true,
      fetchedCancelSubscription: false,
    };
  },
  [types.FETCH_CANCEL_SUBSCRIPTION_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingCancelSubscription: false,
      fetchedCancelSubscription: true,
      subscription: payload,
    };
  },
  [types.FETCH_CANCEL_SUBSCRIPTION_FAILED]: (state) => {
    return {
      ...state,
      fetchingCancelSubscription: false,
      fetchedCancelSubscription: false,
    };
  },

  [types.FETCH_SUBSCRIPTION_PRICING_REQUEST]: (state) => {
    return {
      ...state,
      fetchingSubscriptionPricing: true,
      fetchedSubscriptionPricing: false,
    };
  },
  [types.FETCH_SUBSCRIPTION_PRICING_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingSubscriptionPricing: false,
      fetchedSubscriptionPricing: true,
      subscriptionPricing: payload?.pricing || payload || [],
    };
  },
  [types.FETCH_SUBSCRIPTION_PRICING_FAILED]: (state) => {
    return {
      ...state,
      fetchingSubscriptionPricing: false,
      fetchedSubscriptionPricing: false,
    };
  },

  [types.FETCH_UPDATE_EXCHANGE_REQUEST]: (state) => {
    return {
      ...state,
      fetchedExchange: false,
      fetchedUpdateExchange: false,
      fetchingUpdateExchange: true,
    };
  },
  [types.FETCH_UPDATE_EXCHANGE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedExchange: true,
      fetchedUpdateExchange: true,
      fetchingUpdateExchange: false,
      subscription: payload,
    };
  },
  [types.FETCH_UPDATE_EXCHANGE_FAILED]: (state) => {
    return {
      ...state,
      fetchedExchange: false,
      fetchedUpdateExchange: false,
      fetchingUpdateExchange: false,
    };
  },

  // RESET CHANGE STATUS
  [types.RESET_CHANGE_VEHICLE_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedChangeVehicle: false,
    };
  },

  // RESET SUBSCRIPTION
  [types.RESET_SUBSCRIPTION_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedCancelSubscription: false,
      fetchedChangeVehicle: false,
      fetchedUpdateExchange: false,
      subscription: {},
    };
  },

  // RESET CANCEL SUBSCRIPTION
  [types.RESET_CANCEL_SUBSCRIPTION_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedCancelSubscription: false,
    };
  },

  // RESET EXCHANGE SUBSCRIPTION
  [types.RESET_EXCHANGE_SUBSCRIPTION_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedUpdateExchange: false,
      fetchingUpdateExchange: false,
    };
  },

  // RESET UPDATE SUBSCRIPTION
  [types.RESET_UPDATE_SUBSCRIPTION_SUCCESS]: (state) => {
    return {
      ...state,
      fetchedUpdateSubscription: false,
      fetchingUpdateSubscription: false,
    };
  },

  [types.FETCH_VEHICLE_GROUPS_AGGREGATES_REQUEST]: (state) => {
    return {
      ...state,
      fetchingFleetAggregates: true,
    };
  },
  [types.FETCH_VEHICLE_GROUPS_AGGREGATES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingFleetAggregates: false,
      fleetAggregates: {
        list: payload.data || [],
        pagination: payload.pagination,
      },
    };
  },
  [types.FETCH_VEHICLE_GROUPS_AGGREGATES_FAILED]: (state) => {
    return {
      ...state,
      fetchingFleetAggregates: false,
    };
  },

  [types.FETCH_AGGREGATES_TOTALS_REQUEST]: (state) => {
    return {
      ...state,
      fetchingAggregatesTotals: true,
    };
  },
  [types.FETCH_AGGREGATES_TOTALS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      aggregatesTotals: payload,
      fetchingAggregatesTotals: false,
    };
  },
  [types.FETCH_AGGREGATES_TOTALS_FAILED]: (state) => {
    return {
      ...state,
      fetchingAggregatesTotals: false,
    };
  },
});

export default subscriptionsReducer;
